module.exports = __webpack_public_path__ + "media/components/assets/img/icons/star-empty-b85097968fb42bf5b98e2654f814a7cd.svg";